import { render, staticRenderFns } from "./papwaClass.vue?vue&type=template&id=a3058c00&scoped=true"
import script from "./papwaClass.vue?vue&type=script&lang=js"
export * from "./papwaClass.vue?vue&type=script&lang=js"
import style0 from "./papwaClass.vue?vue&type=style&index=0&id=a3058c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3058c00",
  null
  
)

export default component.exports